export enum ButtonStyles {
  Primary = "spotify-button",
  Secondary = "spotify-button spotify-button--secondary",
}

export enum IconButtonStyles {
  Primary = "icon-button",
  Secondary = "icon-button icon-button--secondary",
}
